module.exports = __webpack_public_path__ + "img/img_2.7ec2ba04.jpg";